import { cmxDateTime, objectUtils } from '@codametrix/ui-common';
export function loadStateClaim(loadState, claim) {
    return {
        ...loadState,
        claim
    };
}
export function isLoadingClaim(loadState) {
    return 'claim' in loadState;
}
/**
 * Method to set append appropriate timezone for given patient timeline entry and prop name(with date str)
 * @param entry
 * @param propName
 * @param timeZoneStr
 * @returns
 */ export function setTimeLineEntryPropTimeZone(entry, propName, timeZoneStr) {
    const propValue = objectUtils.get(entry, propName);
    if (propValue) {
        const parsedDateTime = cmxDateTime.setTimeZoneForDate(timeZoneStr, propValue);
        objectUtils.set(entry, propName, parsedDateTime);
    }
    return entry;
}
